// Copyright (c) 2016 Deere & Company

import {routerActions} from 'react-router-redux';

export const goToStatusChangeRequestView = pin =>
    routerActions.push(`/products/status-change-request/${pin}`);



// WEBPACK FOOTER //
// ./src/product/shared/action-creators/status-change-request-view.js